import { jsonFetch } from "../../../lib/helpers";
import { Room } from "../../../models";
import { getByOwnerIdRoomsWithLicenseUrl } from "./api-url.constants";
import { RoomByOwnerApiDTO } from "./dtos/read-room.api.dto";
import { mapRoomsByOwnerId } from "./mappers/map-rooms-by-owner-id.api.services";

export const getByOwnerIdRoomsWithLicense = async (
  id?: string
): Promise<Pick<Room, "_id" | "name">[]> => {
  const response = await jsonFetch<RoomByOwnerApiDTO>(getByOwnerIdRoomsWithLicenseUrl(id));
  return response.data.rooms.map(mapRoomsByOwnerId);
};
